import { ChangeEventHandler, memo } from 'react'
import { ResumeCourse } from '@rio/types'
import { i18n } from 'builder/utils/i18n'

import { Base, CardComponentProps } from 'builder/components/Card'
import { TextField } from 'builder/components/TextField'
import { formatDateRange } from 'builder/utils/formatDateRange'

import { CardContentWrapper, Field, Row } from 'builder/components/Card/styles'
import { DateRangePickerChangeValue } from 'builder/components/DateRangePicker/types'
import { withAutoFocus } from '../../../../../hocs/AutoFocusHoc'
import { AcquisitionDatePicker } from './AcquisitionDatePicker'

const CoursesCard = memo((props: CardComponentProps<ResumeCourse>) => {
  const { item, autoFocus, onChange, sectionId } = props
  const joiningString = ' ' + i18n.t('builder.resume_editor.labels.at') + ' '
  const title =
    [item.course, item.institution].filter(x => x).join(joiningString) ||
    i18n.t('builder.resume_editor.not_specified')
  const titleDates = formatDateRange(item)

  const updateSimpleField: ChangeEventHandler<HTMLInputElement> = e => {
    onChange(sectionId, item.id, { [e.target.name]: e.target.value }, true)
  }

  const updateDateRange = (val: DateRangePickerChangeValue) => {
    onChange(sectionId, item.id, val, true)
  }

  return (
    <Base title={title} subtitle={titleDates} {...props}>
      <CardContentWrapper>
        <Row>
          <Field>
            <AcquisitionDatePicker
              value={item}
              onChange={val => updateDateRange(val)}
              currentlyLabel={i18n.t('builder.resume_editor.courses_card.currently_acquiring')}
              headingLabel={i18n.t('builder.resume_editor.courses_card.acquisition_label')}
            />
          </Field>

          <Field>
            <TextField
              autoFocus={autoFocus}
              label={i18n.t('builder.resume_editor.courses_card.course')}
              name="course"
              onChange={updateSimpleField}
              value={item.course || ''}
            />
          </Field>
        </Row>
      </CardContentWrapper>
    </Base>
  )
})

export const Courses = withAutoFocus(CoursesCard)
